import { call, delay, takeLatest } from 'redux-saga/effects';
import { GlobalAction, GlobalActions, GlobalPut } from '@ps20-frontend/shop-integration-redux';

export function* watchZahlungsoptionenChanged() {
  yield takeLatest(GlobalActions.ZAHLUNGSOPTIONEN_CHANGED, handleZahlungsoptionenChanged);
}

export function* handleZahlungsoptionenChanged(action: GlobalAction<unknown>) {
  yield delay(500);
  const globalPut = GlobalPut.getInstance();
  yield call(globalPut.put, new GlobalActions().tarifiereShopSync(action));
}
